module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julia Stuart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Julia Stuart is an award-winning journalist and lives in Bahrain. This is her first novel.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BiJWob/tc-custom/9780061877575.jpg?1728259572469",
      "alt": "This image is the cover for the book Matchmaker of Perigord"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Matchmaker of Perigord\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“A hilarious romp.” —Joanne Harris, author of "), _c('i', [_vm._v("Chocolat")])])]), _c('p', [_c('b', [_vm._v("The charming tale of a small French town in which the local barber, whose business is failing as his clients grow older and lose their hair, decides to become the town matchmaker.")])]), _c('p', [_vm._v("Barber Guillaume Ladoucette has always enjoyed great success in his tiny village in southwestern France, catering to the tonsorial needs of Amour-sur-Belle's thirty-three inhabitants. But times have changed. His customers have grown older—and balder. Suddenly there is no longer a call for Guillaume's particular services, and he is forced to make a drastic career change. Since love and companionship are necessary commodities at any age, he becomes the town's official matchmaker and intends to unite hearts as ably as he once cut hair. But alas, Guillaume is not nearly as accomplished an agent of amour, as the disastrous results of his initial attempts amply prove, especially when it comes to arranging his own romantic future.")]), _c('p', [_vm._v("For every reader who adored "), _c('i', [_vm._v("Chocolat")]), _vm._v(", Julia Stuart's "), _c('i', [_vm._v("The Matchmaker of Périgord")]), _vm._v(" is a delectable, utterly enchanting, and sinfully satisfying delight.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0